import React, {useEffect} from "react";
import {Button, Result} from "antd";

const CompanySuccessDialog = ({newCompany, goToCompanies, goToAddLicencesForCompany, clearNewlyAddedCompany}) => {
    useEffect(() => {
        return () => {
            clearNewlyAddedCompany();
        }
    }, []);

    return <Result
        status="success"
        title={<span><b>{newCompany.companyName}</b> successfully saved</span>}
        subTitle="Company successfully saved."
        extra={[
            <Button type="primary" key="console" onClick={goToAddLicencesForCompany}>
                Add Licences for {newCompany.companyName}
            </Button>,
            <Button key='toCompanies' onClick={goToCompanies}>Go back to Companies</Button>,
        ]}
    />
};

export default CompanySuccessDialog;